import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformEncodedUrl } from './encoded-url.transformers';
import type { EncodedUrlCollection } from './encoded-url.types';

export function encodedUrlReducer(
  state: CollectionStateSlice<EncodedUrlCollection> = {},
  action: CollectionActions<EncodedUrlCollection>,
): CollectionStateSlice<EncodedUrlCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'encodedUrl') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<EncodedUrlCollection>(
          state,
          transformIntoDocuments([result], transformEncodedUrl),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
